var __jsx = React.createElement;
import React from "react";
var NewChatModal = function NewChatModal(_ref) {
  var isOpen = _ref.isOpen,
    onConfirm = _ref.onConfirm,
    onCancel = _ref.onCancel;
  if (!isOpen) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dark:bg-gray-800 bg-gray-200 rounded-lg shadow-xl max-w-sm w-full mx-4 overflow-hidden border dark:border-gray-700 border-gray-300"
  }, /*#__PURE__*/React.createElement("div", {
    className: "border-b dark:border-gray-700 border-gray-300 px-6 py-4"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "text-lg font-medium dark:text-white text-gray-600"
  }, "Start New Chat")), /*#__PURE__*/React.createElement("div", {
    className: "p-6 border-b dark:border-gray-700 border-gray-300"
  }, /*#__PURE__*/React.createElement("p", {
    className: "dark:text-gray-300 text-gray-500 mb-6"
  }, "Are you sure you want to start a new chat? This will clear the current conversation."), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-end space-x-4"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: onCancel,
    className: "px-4 py-2 text-base font-medium dark:text-gray-300 text-gray-500 dark:hover:bg-gray-800 hover:bg-gray-100 rounded-md transition-colors duration-200"
  }, "Cancel"), /*#__PURE__*/React.createElement("button", {
    onClick: onConfirm,
    className: "px-4 py-2 text-base font-medium text-white bg-teal-600 hover:bg-teal-700 rounded-md transition-colors duration-200"
  }, "Start New Chat")))));
};
export default NewChatModal;